<template>
  <v-app>
    <v-container fluid class="admin pa-0">
      <div id="adminHeader">
        <div id="topBarLogo"
             @click="$router.push({name: 'admin'})">
          <img src="@/assets/logo-race.png">
        </div>
        <div class="admin-header-controls text-right">
          <div>
            <a v-if="isLoggedIn" class="active">
              {{ userEmail }} |
            </a>
            <a @click="changeLocale('zh')"
               :class="{'active': $i18n.locale === 'zh'}">中文</a> |
            <a @click="changeLocale('en')"
               :class="{'active': $i18n.locale === 'en'}">ENG</a> |
            <a @click="logout" class="active" v-if="isLoggedIn">
              {{ $t('header.logout') }}
            </a>
            <a @click="$router.push({name: 'admin-login'})" class="active" v-if="!isLoggedIn">{{ $t('header.login') }}</a> |
            <router-link :to="{name: 'home'}"
                         class="active">
              <font-awesome-icon icon="door-open"></font-awesome-icon>
            </router-link>
          </div>
        </div>
        <div class="admin-header-nav" v-if="isLoggedIn">
          <router-link :to="{name: 'sasv'}" v-if="$hasPermission('sasv.list')">{{ $t('admin.sasv') }}</router-link>
          <router-link :to="{name: 'hkiarace-user'}" v-if="$hasPermission('hkiarace.list_member')">{{ $t('admin.member') }}</router-link>
          <router-link :to="{name: 'operator'}" v-if="isAdmin">{{ $t('admin.operator') }}</router-link>
          <router-link :to="{name: 'hkiarace'}" v-if="$hasModulePermission('hkiarace')">{{ $t('admin.hkiarace') }}</router-link>
          <router-link :to="{name: 'acc-booking'}" v-if="$hasModulePermission('acc')">{{ $t('admin.acc_booking') }}</router-link>
          <router-link :to="{name: 'settings'}" v-if="$hasPermission('system.settings')">{{ $t('admin.settings') }}</router-link>
        </div>
      </div>
      <router-view></router-view>
    </v-container>
  </v-app>
</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core'
import {faQrcode, faSearch, faDoorOpen} from '@fortawesome/free-solid-svg-icons'

library.add(faQrcode, faSearch, faDoorOpen);

export default {
  name: 'Admin',
  mounted() {
    // Ensure auth is checked (will reuse existing check if already in progress)
    this.$storeDispatch('ensureAuthCheck', {v: this});

    this.$eventHub.$on('logout', () => {
      this.$router.push({name: 'admin-login', query: {logout: '1'}});
    });
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    userEmail() {
      return this.$store.state.user.email;
    },
    isLoggedIn() {
      return !!this.$store.state.user.id;
    },
  },
  methods: {
    logout() {
      if (confirm(this.$t('logout_msg'))) {
        this.$storeDispatch('logout');
        this.$router.push({name: 'admin-login', query: {logout: '1'}});
      }
    },
    changeLocale(locale) {
      this.$cookie.set('locale', locale, {samesite: 'Strict', secure: true});
      window.location.reload();
    },
  },
}
</script>

<style lang="less">
.btn-primary {
  color: #ffffff
}

.admin {
  height: 100vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding: 0;
  text-align: left;

  #adminHeader {
    flex: 0 0 auto;
    height: 110px;
    width: 100%;
    padding: 15px;
    background-color: #62cbd0;
    // z-index: 369;
    overflow: hidden;
    position: relative;

    #topBarLogo {
      background-color: white;
      padding: 10px;
      position: absolute;
      left: 25px;
      cursor: pointer;

      img {
        height: 60px;
      }
    }

    .admin-header-controls {
      position: absolute;
      right: 25px;
      color: white;

      a {
        font-weight: bold;
        text-decoration: none;
        color: #a4a4a4;
        cursor: pointer;

        &.active {
          color: white;
        }

        &:hover {
          color: white;
          text-decoration: underline;
        }
      }
    }

    .admin-header-nav {
      padding-left: 130px;
      padding-top: 30px;

      a {
        font-size: 1.5em;
        font-weight: bold;
        text-decoration: none;
        // margin-left: 30px;
        margin: 0 10px;
        color: #a4a4a4;

        &.router-link-active {
          color: #FFF !important;
          font-weight: bolder;
        }
      }
    }
  }

  #adminNav {
    height: 100px;
    padding: 30px;
    text-align: left;

    a {
      font-size: 1.5em;
      font-weight: bold;
      text-decoration: none;
      margin-left: 30px;
      color: #a4a4a4;

      &.router-link-active {
        font-weight: bold;
        color: #62cbd0;
      }
    }
  }

  .form-group {
    margin-bottom: 1.5rem;

    .col-form-label {
      font-weight: bold;
    }
  }

  h2 {
    font-weight: bold;
  }
}


</style>
